import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { FetchSavedListLists } from '..';

const buildSavedListListsQueryOptions = (
  workspaceId: string,
  queryKey: ReturnType<typeof useQueryKeys>['savedCreatorsList'],
) => ({
  queryKey: queryKey.lists(),
  queryFn: ({ signal }: { signal?: AbortSignal }) => FetchSavedListLists(workspaceId, signal),
});

export const useSavedListLists = () => {
  const { workspaceId } = useWorkspaceId();
  const queryKeys = useQueryKeys();
  return useSuspenseQuery(buildSavedListListsQueryOptions(workspaceId, queryKeys.savedCreatorsList));
};

export const useSavedListListsQuery = () => {
  const { workspaceId } = useWorkspaceId();
  const queryKeys = useQueryKeys();

  return useQuery(buildSavedListListsQueryOptions(workspaceId, queryKeys.savedCreatorsList));
};
